import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { CounterCreateInput, CounterEditInput, CounterOutput, CustomerProviderCredentialsInput, CustomerProviderCredentialsOutput, ProviderInput, ProviderOutput } from "../../models/load_curves.model";
import { Customer, CustomerInput, LoadCurvesCustomerFilters } from "../../models/customer.model";

export const loadCurvesActions = createActionGroup({
    source: 'Load Curves',
    events: {

        //! Providers
        'Get Providers': emptyProps(),
        'Get Providers Success': props<{data: ProviderOutput[]}>(),
        'Get Providers Fail': emptyProps(),

        'Get Single Provider': props<{provider_id: number}>(),
        'Get Single Providers Success': props<{data: ProviderOutput}>(),
        'Get Single Providers Fail': emptyProps(),

        'Edit Provider': props<{provider_id: number, provider_obj: ProviderInput}>(),
        'Edit Providers Success': emptyProps(),
        'Edit Providers Fail': emptyProps(),

        'Create Provider': props<{provider_obj: ProviderInput}>(),
        'Create Providers Success': emptyProps(),
        'Create Providers Fail': emptyProps(),

        //! Customer providers credentials
        'Get Customer Provider Credentials': props<{customer_id: number}>(),
        'Get Customer Provider Credentials Success': props<{data: CustomerProviderCredentialsOutput[]}>(),
        'Get Customer Provider Credentials Fail': emptyProps(),

        'Get Single Customer Provider Credentials': props<{credential_id: number}>(),
        'Get Single Customer Provider Credentials Success': props<{data: CustomerProviderCredentialsOutput}>(),
        'Get Single Customer Provider Credentials Fail': emptyProps(),

        'Edit Customer Provider Credentials': props<{credential_obj: CustomerProviderCredentialsInput}>(),
        'Edit Customer Provider Credentials Success': emptyProps(),
        'Edit Customer Provider Credentials Fail': emptyProps(),

        'Delete Customer Provider Credentials': props<{credential_id: number}>(),
        'Delete Customer Provider Credentials Success': emptyProps(),
        'Delete Customer Provider Credentials Fail': emptyProps(),

        'Create Customer Provider Credentials': props<{credential_obj: CustomerProviderCredentialsInput}>(),
        'Create Customer Provider Credentials Success': emptyProps(),
        'Create Customer Provider Credentials Fail': emptyProps(),

        //! Counter
        'Get Counters': props<{ids: {
            customer_id: number,
            provider_id: number
        }}>(),
        'Get Counters Success': props<{data: CounterOutput[]}>(),
        'Get Counters Fail': emptyProps(),

        'Get Single Counter': props<{counter_id: number}>(),
        'Get Single Counter Success': props<{data: CounterOutput}>(),
        'Get Single Counter Fail': emptyProps(),

        'Edit Counter': props<{counter_obj: CounterEditInput}>(),
        'Edit Counter Success': emptyProps(),
        'Edit Counter Fail': emptyProps(),

        'Delete Counter': props<{counter_id: number}>(),
        'Delete Counter Success': emptyProps(),
        'Delete Counter Fail': emptyProps(),

        'Create Counter': props<{counter_obj: CounterCreateInput}>(),
        'Create Counter Success': emptyProps(),
        'Create Counter Fail': emptyProps(),

        //! Customers
        'Get Customers': props<{data: LoadCurvesCustomerFilters|null}>(),
        'Get Customers Success': props<{payload: Customer[]}>(),
        'Get Customers Fail': emptyProps(),
        
        'Edit Customer': props<{customer_obj: CustomerInput}>(),

        'Delete Customer': props<{customer_id: number}>(),

        'Create Customer': props<{customer_obj: CustomerInput, user_id: number}>(),
    }
})